<template>
  <div />
</template>
<script>
import Cookies from 'js-cookie'
export default {
  created() {
    var id = this.$route.params.id
    if (id) {
      Cookies.set('default_divecenter', id)
    }
    this.$store.dispatch('user/resetToken', '')
    this.$router.replace('/home/index')
  }
}
</script>
